import { Routes, Route } from 'react-router-dom'
import Layout from '@/components/Layout'
import Overview from '@/pages/Overview'
import Services from '@/pages/Services'
import Containers from '@/pages/Containers'
import Topology from '@/pages/Topology'
import Servers from '@/pages/Servers'
import Instances from '@/pages/Instances'
import McpInstanceActions from '@/pages/McpInstanceActions'
import Networks from '@/pages/Networks'
import Certificates from '@/pages/Certificates'
import Dns from '@/pages/Dns'
import { GiteaBotCredentials } from './pages/GiteaBotCredentials'
import SecretStores from '@/pages/SecretStores'
import Login from '@/pages/Login'

export default function App() {
  return (
    <Routes>
      {/* Sign-in — standalone, OUTSIDE the Layout (no sidebar/chrome). The axios
          interceptor sends unauthenticated users here on 401. */}
      <Route path="/login" element={<Login />} />

      {/* Pathless layout route: matches all children, renders Layout shell */}
      <Route element={<Layout />}>
        <Route path="/" element={<Overview />} />
        <Route path="/overview" element={<Overview />} />
        <Route path="/services" element={<Services />} />
        <Route path="/containers" element={<Containers />} />
        <Route path="/topology" element={<Topology />} />
        <Route path="/servers" element={<Servers />} />
        <Route path="/instances" element={<Instances />} />
        <Route path="/mcp-actions" element={<McpInstanceActions />} />
        <Route path="/networks" element={<Networks />} />
        <Route path="/certificates" element={<Certificates />} />
        <Route path="/dns" element={<Dns />} />
        {/* Credentials — Gitea bot PAT management (Phase 1b) */}
        <Route path="/credentials/gitea-bots" element={<GiteaBotCredentials />} />
        {/* Fleet secret-store inventory (ADR-0017 D5) */}
        <Route path="/credentials/secret-stores" element={<SecretStores />} />
      </Route>

      {/* Catch-all OUTSIDE the layout — won't compete with sibling matches */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  )
}

function NotFoundPage() {
  return (
    <div className="min-h-screen bg-background text-foreground p-8">
      <h2 className="text-2xl font-semibold">Not found</h2>
      <p className="text-sm text-muted-foreground mt-2">
        The route <code className="font-mono">{location.pathname}</code> doesn't match any
        registered Control Center page.
      </p>
      <p className="text-sm text-muted-foreground mt-4">
        <a href="/overview" className="text-primary underline">
          Go to Overview
        </a>
      </p>
    </div>
  )
}
